import api from '../utils/api';

const BASE = '/api/ratings';

/**
 * Get the authenticated user's rating for a scenario.
 * @route GET /api/ratings/:scenarioId/user-rating
 * @param {string} scenarioId
 * @returns {Promise<{ score: number }>} score=0 if the user hasn't rated yet
 */
export const getUserRating = (scenarioId) =>
    api.get(`${BASE}/${scenarioId}/user-rating`).then((r) => r.data);

/**
 * Rate a scenario (creates or updates the caller's existing rating).
 * @route POST /api/ratings/:scenarioId
 * @param {string} scenarioId
 * @param {number} score - Integer 1–5
 * @returns {Promise<{ avgRating: number, ratingsCount: number }>} Updated scenario stats
 */
export const rateScenario = (scenarioId, score) =>
    api.post(`${BASE}/${scenarioId}`, { score }).then((r) => r.data);
